import React, { useEffect, useState } from "react";
import {
  MenuProps,
  Button,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Row,
  Col,
  Table,
  Switch,
  Popconfirm,
} from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  BlockedDriver,
  fetchBlockDriverAtten,
  fetchDriverAtten,
} from "src/redux/actions/DriverAttenAction";
import CustomTableLoader from "src/components/common/CustomTableLoader";
import { Inactivemodel } from "src/components/DriverAttenmodels/Inactivemodel";
import "../styles/tableColor.css";

const { Option } = Select;
const DriverAttendance: React.FC = () => {
  const [selectedCabId, setSelectedCabId] = useState<string | null>(null);
  const [showAllInactive, setShowAllInactive] = useState(false);
  const [filterStatus, setFilterStatus] = useState<string>("All Vehicles");
  const [isApproveModalVisible, setApproveModalVisible] = useState(false);
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false);
  const [isInactiveModalVisible, setInactiveModalVisible] = useState(false);
  const [isLeaveModalVisible, setIsLeaveModalVisible] = useState(false);
  const [leaveForm] = Form.useForm();
  const [cabIdFilter, setCabIdFilter] = useState<string>("");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const branchid = userData.cityid;

  const DriverAttenData = useSelector(
    (state: any) => state.driverAtten?.data || {}
  );
  const loading = useSelector((state: any) => state.driverAtten.loading);
  const update = useSelector((state: any) => state.driverAtten.update);

  const {
    data: cabid = [],
    tablelength = 0,
    logoutcount = 0,
    availablecount = 0,
    leavecount = 0,
    ondutycount = 0,
    blockedcount = 0,
    todaycount = 0,
    permissioncount = 0,
    onholdcount = 0,
  } = DriverAttenData || {};

  const filteredDataSource = cabid.filter((record: any) => {
    const searchText = cabIdFilter.toLowerCase();

    const matchesSearch = Object.values(record).some((value) =>
      String(value).toLowerCase().includes(searchText)
    );

    if (filterStatus === "All Vehicles") {
      return matchesSearch;
    }
    // else if (filterStatus === "Logout") {
    //   return matchesSearch && record.driverstatus === "Logout";
    // } else if (filterStatus === "On Leave") {
    //   return matchesSearch && record.driverstatus === "On leave";
    // } else if (filterStatus === "On Trip") {
    //   return (
    //     matchesSearch &&
    //     ([2, 3, 4].includes(record.statuscode) ||
    //       record.appstatus === "On Duty")
    //   );
    // }
    else if (filterStatus === "Inactive") {
      return matchesSearch && record.driverstatus === "Inactive";
    }
    // else if (filterStatus === "Available") {
    //   return (
    //     matchesSearch &&
    //     (record.statuscode === 11 || record.appstatus === "Available")
    //   );
    // } else if (filterStatus === "On Hold") {
    //   return matchesSearch && record.driverstatus === "Hold duty";
    // } else if (filterStatus === "Permission") {
    //   return matchesSearch && record.driverstatus === "On Permission";
    // }

    return matchesSearch;
  });

  useEffect(() => {
    dispatch(fetchDriverAtten(branchid));
  }, []);

  const handleToggleStatus = (record: any, checked: boolean) => {
    const updatedStatus = checked ? 1 : 0;
    const payload = {
      cabid: record.cabid,
      ownername: record.ownername,
      ownermobileno: record.ownermobile,
      userName: userData.employeename,
      status: updatedStatus,
    };
    dispatch(BlockedDriver(payload));
    dispatch(fetchDriverAtten(branchid));
  };

  const columns: any = [
    {
      title: "Cab ID",
      dataIndex: "cabid",
      key: "cabid",
      align: "center",
    },
    {
      title: "Active/Inactive",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (_: any, record: any) => (
        <Popconfirm
          title={`Are you sure you want to ${
            record.status === 1 ? "Inactive" : "Active"
          } this Cab?`}
          onConfirm={() => handleToggleStatus(record, record.status !== 1)}
          okText="Yes"
          cancelText="No"
          placement="top"
        >
          <Switch
            checked={record.status === 1}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
          />
        </Popconfirm>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      align: "center",
      // render: (text: string) => {
      //   if (!text) return "-";
      //   const date = new Date(text);
      //   return date.toLocaleDateString("en-GB");
      // },
    },
    // {
    //   title: "Time",
    //   dataIndex: "dateandtime",
    //   key: "Time",
    //   align: "center",
    //   render: (text: string) => {
    //     if (!text) return "-";
    //     const date = new Date(text);
    //     return date.toLocaleTimeString("en-GB", {
    //       hour: "2-digit",
    //       minute: "2-digit",
    //     });
    //   },
    // },
    ...(filterStatus === "Inactive"
      ? [
          {
            title: "Reason",
            dataIndex: "blockreason",
            key: "Reason",
            align: "center",
          },
        ]
      : []),
    {
      title: "Owner Name",
      dataIndex: "ownername",
      key: "ownername",
      align: "center",
    },
    {
      title: "Owner Mobile",
      dataIndex: "ownermobile",
      key: "ownermobile",
      align: "center",
    },
    {
      title: "vehicle ID",
      dataIndex: "vehicleid",
      key: "vehicleid",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "driverstatus",
      key: "driverstatus",
      align: "center",
    },
  ];
  const getButtonStyle = (
    baseColor: string,
    textColor: string,
    statusKey: string
  ) => ({
    padding: "12px 20px",
    backgroundColor: filterStatus === statusKey ? textColor : baseColor,
    color: filterStatus === statusKey ? "#fff" : textColor,
    border: "none",
    borderRadius: "8px",
    fontWeight: "600",
    boxShadow: `0 2px 6px rgba(0,0,0,0.15)`,
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background-color 0.3s ease",
  });
  const handleApproveClick = () => {
    form.resetFields();
    form.setFieldsValue({
      date: dayjs().format("YYYY-MM-DD"),
      currentTime: dayjs().format("HH:mm:ss"),
    });
    setApproveModalVisible(true);
  };
  const handleApproveSubmit = () => {
    form.validateFields().then((values) => {
      console.log("Submitted Values:", values);
      setApproveModalVisible(false);
    });
  };
  const handleLogoutClick = () => {
    form.resetFields();
    form.setFieldsValue({
      date: dayjs().format("YYYY-MM-DD"),
      currentTime: dayjs().format("HH:mm:ss"),
    });
    setLogoutModalVisible(true);
  };
  const handleLeaveSubmit = () => {
    form.validateFields().then((values) => {
      console.log("Submitted Values:", values);
      setLogoutModalVisible(false);
    });
  };
  const handleLeaveClick = () => {
    form.resetFields();
    form.setFieldsValue({
      date: dayjs().format("YYYY-MM-DD"),
      currentTime: dayjs().format("HH:mm:ss"),
    });
    setIsLeaveModalVisible(true);
  };
  const handleLogoutSubmit = () => {
    form.validateFields().then((values) => {
      console.log("Submitted Values:", values);
      setIsLeaveModalVisible(false);
    });
  };
  const handleInactive = () => {
    setInactiveModalVisible(true);
    const branchid = userData.cityid;
    dispatch(fetchBlockDriverAtten(branchid));
  };

  const attendanceActionItems: MenuProps["items"] = [
    {
      key: "1",
      label: "Revert login",
    },
    {
      key: "2",
      label: "Revert logout",
    },
    {
      key: "3",
      label: "Login",
    },
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Driver Attendance </h2>
      <div style={styles.topRow}>
        <div style={styles.buttonRow}>
          {/* <Button
            style={{ ...styles.button, backgroundColor: "#dc3545" }}
            onClick={handleInactive}
          >
            Inactive
          </Button> */}
          {/* <div style={styles.todayLogin}>Today - {todaycount} </div> */}
          {/* <button style={styles.iconButton}>
            {React.createElement(FaDownload as React.ComponentType)}
          </button> */}
          {/* <button
            style={getButtonStyle("#dbeafe", "#1e8bd4ff", "All Vehicles")}
            onClick={() => setFilterStatus("All Vehicles")}
          >
            Total Vehicles -
          </button> */}
        </div>
        <div style={{ ...styles.searchGroup }}>
          <input
            type="text"
            placeholder="Search "
            style={styles.searchInput}
            value={cabIdFilter}
            onChange={(e) => setCabIdFilter(e.target.value)}
          />
          {/* <div style={styles.searchIconWrapper}>
            <SearchOutlined style={{ color: "white", fontSize: "16px" }} />
          </div> */}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1%",
          marginTop: "2%",
          marginBottom: "2%",
          backgroundColor: "#f9fafb",
          padding: "1% 1%",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          flexWrap: "nowrap",
          justifyContent: "space-around",
        }}
      >
        <button
          style={getButtonStyle("#dbeafe", "#1e3a8a", "All Vehicles")}
          onClick={() => setFilterStatus("All Vehicles")}
          onMouseEnter={(e) =>
            filterStatus !== "All Vehicles" &&
            (e.currentTarget.style.backgroundColor = "#aac8fc")
          }
          onMouseLeave={(e) =>
            filterStatus !== "All Vehicles" &&
            (e.currentTarget.style.backgroundColor = "#dbeafe")
          }
        >
          📊 All - {tablelength}
        </button>
        <button
          style={getButtonStyle("#e0e7ef", "#2c3e50", "Inactive")}
          onClick={() => setFilterStatus("Inactive")}
          onMouseEnter={(e) =>
            filterStatus !== "Inactive" &&
            (e.currentTarget.style.backgroundColor = "#c8d6e5")
          }
          onMouseLeave={(e) =>
            filterStatus !== "Inactive" &&
            (e.currentTarget.style.backgroundColor = "#e0e7ef")
          }
        >
          ❌ Inactive - {blockedcount}
        </button>
        <button
          style={getButtonStyle("#d1e7dd", "#0f5132", "Logout")}
          onClick={() => setFilterStatus("Logout")}
          onMouseEnter={(e) =>
            filterStatus !== "Logout" &&
            (e.currentTarget.style.backgroundColor = "#badbcc")
          }
          onMouseLeave={(e) =>
            filterStatus !== "Logout" &&
            (e.currentTarget.style.backgroundColor = "#d1e7dd")
          }
        >
          ✅ Logout - {logoutcount}
        </button>
        <button
          style={getButtonStyle("#fff3cd", "#664d03", "On Trip")}
          onClick={() => setFilterStatus("On Trip")}
          onMouseEnter={(e) =>
            filterStatus !== "On Trip" &&
            (e.currentTarget.style.backgroundColor = "#ffe08a")
          }
          onMouseLeave={(e) =>
            filterStatus !== "On Trip" &&
            (e.currentTarget.style.backgroundColor = "#fff3cd")
          }
        >
          🚗 On Trip - {ondutycount}
        </button>
        <button
          style={getButtonStyle("#e2e3e5", "#41464b", "Available")}
          onClick={() => setFilterStatus("Available")}
          onMouseEnter={(e) =>
            filterStatus !== "Available" &&
            (e.currentTarget.style.backgroundColor = "#c8cbcf")
          }
          onMouseLeave={(e) =>
            filterStatus !== "Available" &&
            (e.currentTarget.style.backgroundColor = "#e2e3e5")
          }
        >
          🟢 Available - {availablecount}
        </button>
        <button
          style={getButtonStyle("#cff4fc", "#055160", "On Hold")}
          onClick={() => setFilterStatus("On Hold")}
          onMouseEnter={(e) =>
            filterStatus !== "On Hold" &&
            (e.currentTarget.style.backgroundColor = "#9ee9f9")
          }
          onMouseLeave={(e) =>
            filterStatus !== "On Hold" &&
            (e.currentTarget.style.backgroundColor = "#cff4fc")
          }
        >
          ⏸️ On Hold - {onholdcount}
        </button>
        <button
          style={getButtonStyle("#e0d4f7", "#4b0082", "On Leave")}
          onClick={() => setFilterStatus("On Leave")}
          onMouseEnter={(e) =>
            filterStatus !== "On Leave" &&
            (e.currentTarget.style.backgroundColor = "#c1aef2")
          }
          onMouseLeave={(e) =>
            filterStatus !== "On Leave" &&
            (e.currentTarget.style.backgroundColor = "#e0d4f7")
          }
        >
          🟡 On Leave - {leavecount}
        </button>
        <button
          style={getButtonStyle("#fde2e4", "#8a1f3d", "Permission")}
          onClick={() => setFilterStatus("Permission")}
          onMouseEnter={(e) =>
            filterStatus !== "Permission" &&
            (e.currentTarget.style.backgroundColor = "#fbb1bd")
          }
          onMouseLeave={(e) =>
            filterStatus !== "Permission" &&
            (e.currentTarget.style.backgroundColor = "#fde2e4")
          }
        >
          📈 Permission - {permissioncount}
        </button>
      </div>

      <Table
        rowClassName={(record, index) => {
          if (record.driverstatus === "Inactive") {
            if (record.blockreason === "Pending Payment") {
              return "row-PendingPayment";
            }
            if (
              [
                "Uniform",
                "Sticker",
                "Misbehaving",
                "Not Taking Trips",
                "Time Management",
                "Others",
              ].includes(record.blockreason)
            ) {
              return "row-red";
            }
          }

          if (record.driverstatus === "Hold duty") {
            return "row-blue";
          }

          if ([2, 3, 4].includes(record.statuscode)) {
            return "row-trip";
          }

          if (record.driverstatus === "On Permission") {
            return "row-permission";
          }

          if (record.statuscode === 11) {
            return "row-available";
          }

          if (record.driverstatus === "On leave") {
            return "row-leave";
          }

          return index % 2 === 0 ? "table-row-light" : "table-row-dark";
        }}
        loading={{
          spinning: loading,
          indicator: <CustomTableLoader />,
        }}
        dataSource={filteredDataSource}
        columns={columns}
        rowKey={(record) => record.cab_id || record.cabid}
        bordered
        locale={{ emptyText: "No history yet." }}
        scroll={{ x: "calc(500px + 50%)", y: 50 * 15 }}
      />

      <Modal
        open={isApproveModalVisible}
        footer={null}
        closable={true}
        onCancel={() => setApproveModalVisible(false)}
        centered
        title={
          <div
            style={{
              fontSize: "22px",
              fontWeight: "bold",
              color: "purple",
              textAlign: "center",
            }}
          >
            Approve
          </div>
        }
        modalRender={(node) => (
          <div
            style={{
              border: "4px solid purple",
              borderRadius: "16px",
              padding: "4px",
              backgroundColor: "#e6f7ff",
              boxShadow: "0 0 24px rgba(0, 0, 0, 0.3)",
            }}
          >
            {node}
          </div>
        )}
        bodyStyle={{
          padding: 24,
          borderRadius: 12,
          backgroundColor: "#fff",
        }}
      >
        <Form
          form={form}
          layout="horizontal"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={handleApproveSubmit}
          style={{ maxWidth: 600, margin: "0 auto" }}
        >
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Cab ID</span>}
            name="cabId"
            rules={[{ required: true, message: "Please select a Cab ID" }]}
          >
            <Select
              placeholder="Select Cab ID"
              style={{ height: 40, borderRadius: 8 }}
            >
              {/* {vehicleData.map((vehicle) => (
                <Option key={vehicle.cabId} value={vehicle.cabId}>
                  {vehicle.cabId}
                </Option>
              ))} */}
            </Select>
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Date</span>}
            name="date"
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Request Time</span>}
            name="requestTime"
            rules={[{ required: true, message: "Please enter request time" }]}
          >
            <Input placeholder="" style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Previous Km </span>}
            name="previousKm"
            rules={[{ required: true, message: "Please enter previous KM" }]}
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Opening Km </span>}
            name="openingKm"
            rules={[{ required: true, message: "Please enter opening KM" }]}
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>

          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Current Time </span>}
            name="currentTime"
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              htmlType="submit"
              type="primary"
              style={{
                backgroundColor: "purple",
                borderRadius: 6,
                fontWeight: "bold",
                padding: "6px 30px",
                fontSize: 16,
                margin: "10px ",
              }}
            >
              Approve
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* 2 */}
      <Modal
        open={isLogoutModalVisible}
        footer={null}
        closable={true}
        onCancel={() => setLogoutModalVisible(false)}
        centered
        title={
          <div
            style={{
              fontSize: "22px",
              fontWeight: "bold",
              color: "purple",
              textAlign: "center",
            }}
          >
            Logout
          </div>
        }
        modalRender={(node) => (
          <div
            style={{
              border: "4px solid purple",
              borderRadius: "16px",
              padding: "4px",
              backgroundColor: "#e6f7ff",
              boxShadow: "0 0 24px rgba(0, 0, 0, 0.3)",
            }}
          >
            {node}
          </div>
        )}
        bodyStyle={{
          padding: 24,
          borderRadius: 12,
          backgroundColor: "#fff",
        }}
      >
        <Form
          form={form}
          layout="horizontal"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={handleLogoutSubmit}
          style={{ maxWidth: 600, margin: "0 auto" }}
        >
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Cab ID</span>}
            name="cabId"
            rules={[{ required: true, message: "Please select a Cab ID" }]}
          >
            <Select
              placeholder="Select Cab ID"
              style={{ height: 40, borderRadius: 8 }}
            >
              {/* {vehicleData.map((vehicle) => (
                <Option key={vehicle.cabId} value={vehicle.cabId}>
                  {vehicle.cabId}
                </Option>
              ))} */}
            </Select>
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Date</span>}
            name="date"
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Request Time</span>}
            name="requestTime"
            rules={[{ required: true, message: "Please enter request time" }]}
          >
            <Input placeholder="" style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Previous Km </span>}
            name="previousKm"
            rules={[{ required: true, message: "Please enter previous KM" }]}
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Opening Km </span>}
            name="openingKm"
            rules={[{ required: true, message: "Please enter opening KM" }]}
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Closing Km </span>}
            name="closingKm"
            rules={[{ required: true, message: "Please enter closing KM" }]}
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            label={<span style={{ fontWeight: "700" }}>Current Time </span>}
            name="currentTime"
          >
            <Input style={{ height: 40, borderRadius: 8 }} />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              htmlType="submit"
              type="primary"
              style={{
                backgroundColor: "purple",
                borderRadius: 6,
                fontWeight: "bold",
                padding: "6px 30px",
                fontSize: 16,
                margin: "10px ",
              }}
            >
              Approve
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* 3 */}
      <Modal
        open={isLeaveModalVisible}
        footer={null}
        closable={true}
        onCancel={() => setIsLeaveModalVisible(false)}
        centered
        title={
          <div
            style={{
              fontSize: "22px",
              fontWeight: "bold",
              color: "purple",
              textAlign: "center",
            }}
          >
            Leave
          </div>
        }
        modalRender={(node) => (
          <div
            style={{
              border: "4px solid purple",
              borderRadius: "16px",
              padding: "4px",
              backgroundColor: "#e6f7ff",
              boxShadow: "0 0 24px rgba(0, 0, 0, 0.3)",
            }}
          >
            {node}
          </div>
        )}
        bodyStyle={{
          padding: 24,
          borderRadius: 12,
          backgroundColor: "#fff",
        }}
      >
        <Form
          form={leaveForm}
          layout="vertical"
          onFinish={handleLeaveSubmit}
          style={{ maxWidth: 500, margin: "0 auto" }}
        >
          <Form.Item
            name="cabId"
            label={<span style={{ fontWeight: "700" }}>Cab ID</span>}
            rules={[{ required: true, message: "Please select a Cab ID" }]}
          >
            <Select
              placeholder="Select Cab ID"
              style={{ height: 40, borderRadius: 8 }}
            >
              {/* {vehicleData.map((vehicle) => (
                <Select.Option key={vehicle.cabId} value={vehicle.cabId}>
                  {vehicle.cabId}
                </Select.Option>
              ))} */}
            </Select>
          </Form.Item>
          <Row gutter={16} align="bottom">
            <Col span={12}>
              <Form.Item
                name="fromDate"
                label={<span style={{ fontWeight: "700" }}>From Date</span>}
                rules={[{ required: true, message: "Please select from date" }]}
              >
                <DatePicker
                  style={{ width: "100%", height: 40, borderRadius: 8 }}
                />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item
                name="toDate"
                label={<span style={{ fontWeight: "700" }}>To Date</span>}
                rules={[{ required: true, message: "Please select to date" }]}
              >
                <DatePicker
                  style={{ width: "100%", height: 40, borderRadius: 8 }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="reason"
            label={<span style={{ fontWeight: "700" }}>Reason</span>}
            rules={[{ required: true, message: "Please select a reason" }]}
          >
            <Select
              placeholder="Select Reason"
              style={{ height: 40, borderRadius: 8 }}
            >
              <Select.Option value="Personal">Maintenance</Select.Option>
              <Select.Option value="Medical">Medical Leave</Select.Option>
              <Select.Option value="Emergency">Emergency</Select.Option>
              <Select.Option value="Other">Personal Leave</Select.Option>
              <Select.Option value="Other">Other</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item style={{ textAlign: "center", marginTop: 24 }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "purple",
                borderColor: "purple",
                color: "white",
                fontWeight: "bold",
                padding: "6px 24px",
                borderRadius: 6,
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* 4 */}
      <Inactivemodel
        isInactiveModalVisible={isInactiveModalVisible}
        setInactiveModalVisible={setInactiveModalVisible}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
    </div>
  );
};
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: "100vh",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginTop: "0px",
    color: "#333",
  },
  iconButtons: {
    backgroundColor: "burlywood",
    color: "#fff",
    fontSize: "24px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "8px",
    padding: "10px 14px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
    transition: "background-color 0.3s",
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "0px",
  },
  buttonRow: { display: "flex", width: "20%" },
  button: {
    backgroundColor: "#007bff",
    border: "none",
    color: "#fff",
    padding: "12px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    boxShadow: "0 4px 12px rgba(67, 68, 70, 0.5)",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    fontSize: "15px",
  },
  iconButton: {
    backgroundColor: "#198754",
    border: "none",
    color: "#fff",
    padding: "12px 16px",
    borderRadius: "8px",
    fontWeight: "600",
    boxShadow: "0 4px 12px rgba(25,135,84,0.5)",
    cursor: "pointer",
  },
  todayLogin: {
    fontSize: "20px",
    fontWeight: "700",
    color: "purple",
    textShadow: "0px 2px 2px grey",
    marginLeft: "auto",
  },
  searchGroup: { position: "relative", marginLeft: "auto" },
  searchInput: {
    width: "100%",
    padding: "10px 40px 10px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    outline: "none",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  },
  searchIconWrapper: {
    position: "absolute",
    right: "5px",
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: "purple",
    padding: "6px 10px",
    borderRadius: "0 6px 6px 0",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
    height: "38px",
  },
};
export default DriverAttendance;
